import { Link } from "react-router-dom";
import Seo from "../components/Seo";

const articles = [
  {
    title: "The Architecture of Agentic AI Systems",
    slug: "/insights/architecture-of-agentic-ai-systems",
    description:
      "A visual primer on reasoning loops, agent memory, multi-agent topologies, the MCP and A2A protocol stack, and the risks to plan for in production.",
    category: "AI Engineering",
    date: "October 29, 2026",
  },
  {
    title: "Securing Cloud Applications in the Age of AI Agents",
    slug: "/insights/securing-cloud-applications-ai-agents",
    description:
      "A practical six-layer framework for securing AI workloads in the cloud: Identity, Connectivity, Execution, Credentials, Data, and Detection.",
    category: "AI Security",
    date: "October 29, 2026",
  },
  {
    title: "What Is an AI Agent?",
    slug: "/insights/what-is-an-ai-agent",
    description:
      "A technical primer for engineers building AI agent systems, from planning and memory to MCP, A2A, and production failure modes.",
    category: "AI Engineering",
    date: "July 8, 2026",
  },
];

export default function Insights() {
  return (
    <>
      <Seo
        title="Insights | Zero Harm AI"
        description="Practical writing on AI systems, security, and software architecture from Zero Harm AI — field notes and technical explainers for teams building production AI applications."
        socialDescription="Practical writing on AI systems, security, and software architecture from Zero Harm AI."
        path="/insights"
      />

      <div className="max-w-5xl mx-auto px-4 py-10">
        <section className="mb-10">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-700 mb-3">
            Insights
          </p>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Practical writing on AI systems, security, and software architecture.
          </h1>
          <p className="text-gray-700 max-w-3xl">
            Field notes and technical explainers from Zero Harm AI for teams building
            production AI applications.
          </p>
        </section>

        <section className="grid grid-cols-1 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="block bg-white border border-gray-200 rounded-xl p-6 shadow-xs hover:shadow-md transition"
            >
              <div className="flex flex-wrap items-center gap-3 text-sm text-gray-500 mb-3">
                <span className="font-semibold text-blue-700">
                  {article.category}
                </span>
                <span>{article.date}</span>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                {article.title}
              </h2>
              <p className="text-gray-700 mb-4">{article.description}</p>
              <span className="text-blue-700 font-semibold">Read article →</span>
            </Link>
          ))}
        </section>
      </div>
    </>
  );
}
